import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { select, Store } from '@ngrx/store';

import { SeriesOption } from 'echarts';
import { cloneDeep, isNull } from 'lodash-es';
import { combineLatest } from 'rxjs';

import { turnoverChartOptions } from '../../../../constants/turnover-chart-options.constants';
import { MainTabBasePathEnum } from '../../../../enums/main-tabs';
import { ProfileSearchEnum } from '../../../../enums/profile-search';
import * as fromWalkingFarmActions from '../../../../store/actions/walking-farm.actions';
import * as fromOrganizationSelectors from '../../../../store/selectors/organization.selectors';
import * as fromWalkingFarmSelectors from '../../../../store/selectors/walking-farm.selectors';

interface SaveFarmFormGroup {
  name: FormControl<string | null>;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-walking-farm-save',
  standalone: false,
  templateUrl: './save.component.html'
})
export class SavePageComponent {
  private activatedRoute = inject(ActivatedRoute);
  private store = inject(Store);

  turnoverRateEnabled = true;
  totalProperties = 0;
  messages: string[] = [];
  tur = false;

  form: FormGroup<SaveFarmFormGroup> = new FormGroup<SaveFarmFormGroup>({
    name: new FormControl<string>('', Validators.required)
  });

  chartOptions = cloneDeep(turnoverChartOptions);

  defaultBackHref: string | undefined;
  defaultHref: string;

  constructor() {
    this.defaultBackHref = this.activatedRoute.snapshot.data['defaultBackHref'];
    this.defaultHref = [this.defaultBackHref ?? '', 'walking-farm'].join('/');

    combineLatest([
      this.store.pipe(select(fromWalkingFarmSelectors.selectSummary)),
      this.store.pipe(select(fromOrganizationSelectors.selectTurnoverRateEnabled))
    ]).subscribe(([{ errorMessage, messages, total, turnoverRate }, turnoverRateEnabled]) => {
      this.turnoverRateEnabled = turnoverRateEnabled;
      this.totalProperties = total;
      this.messages = messages;
      if (this.turnoverRateEnabled) {
        (this.chartOptions.series as SeriesOption[])[0].data = [{ value: turnoverRate ?? 0 }];
      }
      if (!isNull(errorMessage)) {
        this.form.controls.name.setErrors({
          invalid: errorMessage
        });
      } else {
        this.form.controls.name.setErrors(null);
      }
    });
  }

  onSubmit() {
    if (this.form.valid && this.form.getRawValue().name) {
      const name = this.form.getRawValue().name;
      if (name) {
        this.store.dispatch(
          fromWalkingFarmActions.loadFarmDetails({
            payload: {
              name,
              searchType:
                this.defaultBackHref === MainTabBasePathEnum.PropertySearch
                  ? ProfileSearchEnum.PropertySearchWalkingFarm
                  : ProfileSearchEnum.WalkingFarm
            }
          })
        );
      }
    }
  }
}
